<template>
  <div>
    <div class="page page__list" v-if="!listMode">
      <search-bar
        @search="onSearch"
        name="cu_code,cu_name,cc_tel,cu_industry,cu_invoiceinfo"
        placeholder="输入客户编号、名称、地址、行业进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/document/customer/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.cu_name}}</p>
            <p class="list-item-muted">{{item.cu_type}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.cu_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.cu_audit_status=='已审核'}"
            >{{item.cu_audit_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
      <add-button to="/document/customer_edit" />
    </div>
    <div class="page page__list" v-if="listMode==1">
      <search-bar
        @search="onSearch"
        name="cc_code,cc_cuname_new,cc_cuname_old"
        placeholder="输入单号、新旧企业名称进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/document/customer_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.cc_cuname_new}}</p>
            <p class="list-item-muted">{{item.cc_cuname_old}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.cc_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.cc_status=='已审核'}"
            >{{item.cc_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
    </div>
    <div class="page page__list" v-if="listMode==2">
      <search-bar
        @search="onSearch"
        name="cu_code,cu_name,cc_tel"
        placeholder="输入客户编号、名称进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="toUnLock(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.cu_name}}</p>
            <p class="list-item-muted">{{item.cl_reason}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.cu_code}}</p>
            <span v-if="item.cl_cunid" class="list-item-status warning">解挂中</span>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
    </div>
  </div>

</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      listMode: 0,
      listUrl: "/api/document/customer/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "cu_audit_status_code!='AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "cu_audit_status_code='AUDITED'"
            },
            {
              value: 3,
              label: "待变更",
              condition: "cc_statuscode='SUBMITTED' and ifnull(cu_kind,'Customer')='Customer'"
            },
            {
              value: 4,
              label: "已变更",
              condition: "cc_statuscode='AUDITED' and ifnull(cu_kind,'Customer')='Customer'"
            },
            {
              value: 5,
              label: "已挂起",
              condition: "ifnull(cu_kind,'Customer')='Customer'"
            }
          ]
        }, {
          type: 'combo',
          label: '客户分类',
          name: 'cu_type',
          url: '/api/document/customerkind/getCombo'
        }
      ]
    };
  },
  methods: {
    getMode() {
      var me = this, filterBar = me.$refs.filterBar, searchBar = me.$refs.searchBar;
      if (searchBar && searchBar.getCondition()) {
        // search-bar有明细cc_tel字段
        return 'DETAIL';
      }
      if (filterBar) {
        return filterBar.getMode();
      }
      return 'MAIN';
    },
    beforeFilterChange(filter, filterBar, next) {
      let listMode = 0
      if (filter.value == 5) {
        this.listUrl = '/api/document/customer/lockCustomer/list'
        listMode = 2
      } else if (filter.value > 2) {
        this.listUrl = '/api/customer/change/list'
        listMode = 1
      } else {
        this.listUrl = '/api/document/customer/list'
      }
      this.listMode = listMode
      filterBar.initConfig()
      next()
    },
    /**
     * 解挂申请
     */
    toUnLock(item) {
      if (item.cl_cunid) {
        this.$router.push('/document/customer_unlock/' + item.cl_cunid)
      } else {
        this.$router.push({
          name: "DocumentCustomerUnLockEdit",
          params: {
            initData: {
              main: {
                id: null,
                cun_cuid: item.id,
                cun_cucode: item.cu_code,
                cun_cuname: item.cu_name,
                cun_clid: item.cl_clid,
                cun_enddate: null,
                cun_status: '未审核',
                cun_statuscode: 'UNAUDITED',
                cun_remark: null
              }
            },
          }
        });
      }
    }
  }
};
</script>